import {
  PUSH_NOTIFICATION_REQUEST,
  TOGGLE_PUSH_NOTIFICATION,
  UPDATE_PUSH_NOTIFICATION,
} from './constants'

export default function () {
  const initialState = {
    data: {},
    error: null,
    loader: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case PUSH_NOTIFICATION_REQUEST.INITIATE:
        return { ...state, loader: true }
      case PUSH_NOTIFICATION_REQUEST.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          loader: false,
        }
      case PUSH_NOTIFICATION_REQUEST.ERROR:
        return { ...state, error: action.error, loader: false }
      case PUSH_NOTIFICATION_REQUEST.CANCEL:
        return { ...state, loader: false }
      case UPDATE_PUSH_NOTIFICATION.INITIATE:
        return { ...state, loader: true, error: null }
      case UPDATE_PUSH_NOTIFICATION.SUCCESS:
        return {
          ...state,
          loader: false,
        }
      case UPDATE_PUSH_NOTIFICATION.ERROR:
        return { ...state, error: action.error, loader: false }
      case UPDATE_PUSH_NOTIFICATION.CANCEL:
        return { ...state, loader: false }
      case TOGGLE_PUSH_NOTIFICATION:
        return {
          ...state,
          data: {
            ...state.data,
            [action.payload.name]: action.payload.state,
          },
        }
      default:
        return state
    }
  }
}
